<template>
  <qx-card-form title="银行卡信息" :defaultContentShow="false">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="140px">
      <section class="titleLine" slot="bandCard">
        <span>银行卡信息</span>
        <span @click="toAddBankCard()" :disabled="isDisabled" style="color: #0088FF;" v-show="!isAddBankCard">+ 新增银行卡</span>
      </section>
      <section class="titleLine" slot="bandCard2">
        <span>银行卡信息2</span>
        <span @click="toDelBankCard()" style="color: #0088FF;">- 删除银行卡</span>
      </section>
    </qx-custom-form>
    <qx-custom-form :noSubBtn="true" ref="otherForm" :formData="otherForm" labelWidth="140px">
      <section class="titleLine" slot="eCard">
        <span>工行E卡信息</span>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      userInfo: null,
      isDisabled: false,
      isAddBankCard: false, // 判断银行卡是否新增
      baseForm: {
        inline: true,
        form: [
          {
            value: 'bandCard',
            allCustom: true,
          },
          {
            label: '银行卡照片',
            value: 'bankPhoneUrl',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
          },
          {
            label: '账户名',
            value: 'acctName',
            type: 'input',
          },
          {
            label: '银行卡号',
            value: 'acctNo',
            type: 'input',
          },
          {
            label: '开户行',
            value: 'bankName',
            type: 'input',
            attr: {
              maxlength: 50,
            },
          },
          {
            label: '备注',
            value: 'remark',
            type: 'input',
            attr: {
              maxlength: 20,
            },
          },
        ],
        rules: {
          acctNo: [
            { validator: this.checkBankCard, trigger: 'blur' },
          ],
          acctNo2: [
            { validator: this.checkBankCard, trigger: 'blur' },
          ],
        },
      },
      otherForm: {
        inline: true,
        form: [
          {
            value: 'eCard',
            allCustom: true,
          },
          {
            label: '工行E卡注册账号',
            value: 'icbcEcardRegisAccount',
            type: 'input',
          },
        ],
      },
    };
  },
  methods: {
    setBaseForm (linkman) {
      this.$refs.baseForm.setVal('acctName', String(linkman));
      const hasAcctName2 = Object.prototype.hasOwnProperty.call(this.baseForm, 'acctName2');
      if (hasAcctName2) {
        this.$refs.baseForm.setVal('acctName2', linkman);
      }
    },
    // 新增银行卡
    toAddBankCard () {
      const bandCardCount = this.baseForm.form.filter((item) => item.label === '账户名').length;
      if (bandCardCount <= 1) {
        let form = JSON.parse(JSON.stringify(this.baseForm.form));

        form.forEach((item) => {
          item.value = item.value + 2;
        });
        this.baseForm.form.push(...form);
        const acctName = this.$refs.baseForm.getVal('acctName');
        if (acctName) {
          this.$refs.baseForm.setVal('acctName2', acctName);
        }
        this.isAddBankCard = true;
      } else {
        this.isDisabled = true;

      }
    },
    // 删除银行卡
    toDelBankCard () {
      this.baseForm.form.splice(
        this.baseForm.form.findIndex((item) => item.label === '备注') + 1
      );
      this.isAddBankCard = false;
    },
    async handleSubData (cache) {
      let formData;
      let otherFormData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
        otherFormData = await this.$refs.otherForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
        otherFormData = await this.$refs.otherForm.sub();
      }
      if (formData || cache) {
        if (formData.bankPhoneUrl && formData.bankPhoneUrl.length) {
          formData.bankPhoneUrlId = formData.bankPhoneUrl[0].id;
          formData.bankPhoneUrl = formData.bankPhoneUrl[0].url;
        }
        if (formData.bankPhoneUrl2 && formData.bankPhoneUrl2.length) {
          formData.bankPhoneUrlId2 = formData.bankPhoneUrl2[0].id;
          formData.bankPhoneUrl2 = formData.bankPhoneUrl2[0].url;
        }
        let data = [
          {
            bankPhoneUrl: formData.bankPhoneUrl,
            acctName: formData.acctName,
            acctNo: formData.acctNo,
            bankName: formData.bankName,
            remark: formData.remark,
          },
        ];
        if (this.isAddBankCard) {
          data.push({
            bankPhoneUrl: formData.bankPhoneUrl2,
            acctName: formData.acctName2,
            acctNo: formData.acctNo2,
            bankName: formData.bankName2,
            remark: formData.remark2,
          });
        }
        const isDataValid = data.every((item) => Object.values(item).every((value) => value === '' || value === null || value === undefined));
        // 判断没填任何信息时，accountBankList传空
        formData = {
          accountBankList: isDataValid ? [] : JSON.stringify(data),
          icbcEcardRegisAccount: otherFormData.icbcEcardRegisAccount,
        };
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      res.accountBankList = res.accountBankList.length !== 0 ? JSON.parse(res.accountBankList) : res.accountBankList;
      return res;
    },

    async sub () {
      let formData = await this.handleSubData();
      console.log('formData', formData);
      return formData;
    },
    async init (data = {}) {
      this.$refs.baseForm.reset();

      await this.toDelBankCard();
      if (data.accountBankList && data.accountBankList.length > 1) {
        await this.toAddBankCard();
      }
      data.accountBankList && data.accountBankList.forEach((item, index) => {
        if (item.bankPhoneUrl) {
          data[`bankPhoneUrl${index ? index + 1 : ''}`] = item.bankPhoneUrl ? [{ id: index + 1, url: item.bankPhoneUrl }] : [];
        }
        data[`acctName${index ? index + 1 : ''}`] = item.acctName;
        data[`acctNo${index ? index + 1 : ''}`] = item.acctNo;
        data[`bankName${index ? index + 1 : ''}`] = item.bankName;
        data[`remark${index ? index + 1 : ''}`] = item.remark;
      });
      this.$refs.baseForm.setVal(data);
      this.$refs.otherForm.setVal(data);
      if (data.linkman && !data.acctName) {
        this.$refs.baseForm.setVal('acctName', data.linkman);
      }
    },
  },

};
</script>

<style scoped lang="scss">
.titleLine {
  background-color: #f3f3f3;
  height: 40px;
  line-height: 40px;
  padding-left: 40px;
  padding-right: 40px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
}
</style>
